export const ClinicIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0229492" width="24.1283" height="23.2204" fill="white" />
    <path
      d="M2.01068 8.91203L12.0641 2.92554L22.1176 8.91203"
      stroke="#8090A9"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8835 12.7217V19.6878C19.8835 20.0485 19.5834 20.3409 19.2132 20.3409H4.91498C4.54482 20.3409 4.24475 20.0485 4.24475 19.6878V12.7217"
      stroke="#8090A9"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9259 17.0755H10.2024V14.5359H7.59595V10.9076H10.2024V8.36792H13.9259V10.9076H16.5324V14.5359H13.9259V17.0755Z"
      fill="#8090A9"
      stroke="#8090A9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
